export default {
  TABLET_INDENT: '25px',
  MOBILE_INDENT: '10px',
};
